import { render, staticRenderFns } from "./item_perc.vue?vue&type=template&id=ca88bcf2&"
import script from "./item_perc.vue?vue&type=script&lang=js&"
export * from "./item_perc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca88bcf2')) {
      api.createRecord('ca88bcf2', component.options)
    } else {
      api.reload('ca88bcf2', component.options)
    }
    module.hot.accept("./item_perc.vue?vue&type=template&id=ca88bcf2&", function () {
      api.rerender('ca88bcf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/desempenho/item_perc.vue"
export default component.exports